import React from 'react';

const InputField = props => {
  const [fieldProps, setFieldProps] = React.useState({
    id: 1,
    locked: false,
    focussed: false,
    value: '',
    error: '',
    label: props.label,
    placeholder: props.placeholder
  });

  const onChange = event => {
    const value = event.target.value;
    props.setValue(value);
  };

  const fieldClassName = `input-field${props.small ? ' smaller' : ''}${(fieldProps.focussed || fieldProps.value) ? ' focussed' : ''}${props.value ? ' filled' : ''}`;

  // console.log(fieldProps);

  return (
    <div>
      <div className={fieldClassName}>
        <input
          id={1}
          onKeyPress={props.onKeyPress}
          name={props.name}
          type={props.type || 'text'}
          value={props.value}
          placeholder={fieldProps.placeholder}
          onChange={onChange}
          onFocus={() => !fieldProps.locked && setFieldProps(old => ({ ...old, focussed: true }))}
          onBlur={() => !fieldProps.locked && setFieldProps(old => ({ ...old, focussed: false }))}
        />
        <label htmlFor={1} className={fieldProps.error && 'error'}>
          {fieldProps.error || fieldProps.label}
        </label>
      </div>
    </div>
  );
};
export default InputField;
